import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const LowCreditsWarning = () => {
    const [appProperties] = useContext(AppContext);
    const [BalanceCredits, setBalanceCredits] = useState(null);
    useEffect(() => {
      if (appProperties.licenseObj != null) {
        let licenseInfo = appProperties.licenseObj.licenseDetails;
        if (licenseInfo !== null && licenseInfo !== undefined) {
          setBalanceCredits(licenseInfo?.creditsPurchased - licenseInfo?.creditsConsumed);
        }
      }
    }, [appProperties.licenseObj]);
    return (
      <>
        {BalanceCredits < 10 && appProperties?.licenseObj?.licenseDetails?.creditsPurchased > 0 ? (
          <div
            className="p-1 m-3 rounded d-flex align-items-center"
            style={{
              border: "1px solid #F44336",
              backgroundColor: "#FFEBEE",
            }}
          >
            <ExclamationCircleOutlined
              className="pe-2"
              style={{
                color: "#F44336",
                fontSize: 20,
              }}
            />
            Low balance in your wallet, top up for uninterrupted service
          </div>
        ) : null}
      </>
    );
};

export default LowCreditsWarning;